<template>
  <v-container fluid grid-list-xl>
    <v-card>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-side-icon><v-icon>storage</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{$tc('app.box', 2)}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div
          v-if="$vuetify.breakpoint.smAndDown"
          slot="extension"
          class="white--text w-100"
        >
          <v-text-field
            type="text"
            v-model="filterText"
            @keyup.enter="doFilter"
            :placeholder="$t('box.filterPlaceholder')"
            single-line
            hide-details
          ></v-text-field>
        </div>

        <v-text-field
          v-if="$vuetify.breakpoint.mdAndUp"
          type="text"
          v-model="filterText"
          @keyup.enter="doFilter"
          :placeholder="$t('box.filterPlaceholder')"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          @click.prevent="doFilter"
          icon
        >
          <v-icon>search</v-icon>
        </v-btn>

        <v-btn
          @click.prevent="resetFilter"
          icon
        >
          <v-icon>restore</v-icon>
        </v-btn>
        <transition
          enter-active-class="animated bounceIn"
          leave-active-class="animated bounceOut"
        >
          <v-btn
            v-if="selectedRows !== undefined && selectedRows.length !== 0"
            @click.prevent="massDeleteModalVisible = true"
            icon
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </transition>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          v-show="loading"
          slot="progress"
          color="accent"
          indeterminate
        ></v-progress-linear>
        <vuetable ref="vuetable"
          :api-url="`${this.apiUrl}api/boxes/all`"
          data-path="data"
          pagination-path="meta"
          track-by="id"
          :http-fetch="httpFetch"
          :fields="fields"
          :css="css.table"
          :sort-order="sortOrder"
          :multi-sort="true"
          :append-params="moreParams"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loading="onLoading"
          @vuetable:loaded="onLoaded"
        >
          <div slot="actions-slot" slot-scope="props">
            <v-btn
              @click.native="getBoxStats(props.rowData.id)"
              flat
              icon
            >
              <v-icon>insert_chart</v-icon>
            </v-btn>
            <v-btn
              @click.native="syncBox(props.rowData.id)"
              flat
              icon
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn
              @click.native="syncBoxPlaylist(props.rowData.id)"
              flat
              icon
            >
              <v-icon>playlist_play</v-icon>
            </v-btn>
            <v-btn
              @click.native="syncBoxMedia(props.rowData.id)"
              flat
              icon
            >
              <v-icon>perm_media</v-icon>
            </v-btn>
            <v-btn
              @click.native="showEditBoxDialog(props.rowData)"
              flat
              icon
            >
              <v-icon>mdi mdi-television-box</v-icon>
            </v-btn>
          </div>
        </vuetable>
      </v-card-text>

      <v-card-actions>
        <vuetable-pagination ref="pagination"
          :css="css.pagination"
          @vuetable-pagination:change-page="onChangePage"
        ></vuetable-pagination>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="editModalVisible" max-width="500px">
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline">{{ $t("admin.editBox") }}</h3>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex>
              <v-text-field
                v-model="currentBox.magio_user.username"
                name="name"
                prepend-icon="person"
                type="text"
                :label="$t('admin.magioUserUsername')"
                single-line
              ></v-text-field>
              <v-text-field
                v-model="currentBox.magio_user.password"
                name="password"
                prepend-icon="lock"
                type="password"
                :label="$t('admin.magioUserPassword')"
                single-line
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="editModalVisible = false"
            flat
          >{{ $t("general.close") }}</v-btn>
          <v-btn
            @click.prevent="editBox()"
            flat
          >{{ $t("general.edit") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import VueTableMixin from '@/components/generic/VueTableMixin';
import VueTableMaterialDesignCheckbox from '@/components/generic/VueTableMaterialDesignCheckbox.vue';
import { REQUEST_BOX_STATS } from '@/store/actions/boxes';
import BoxNoteEditInput from '@/components/boxes/BoxNoteEditInput.vue';

export default {
  mixins: [
    VueTableMixin,
  ],
  data() {
    return {
      fields: [
        {
          name: VueTableMaterialDesignCheckbox,
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'id',
          title: 'ID',
          sortField: 'id',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'name',
          sortField: 'name',
          title: this.$i18n.t('general.name'),
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: BoxNoteEditInput,
          title: this.$i18n.t('general.note'),
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'actions-slot',
          title: this.$i18n.tc('general.action', 2),
          titleClass: 'text-xs-center',
          dataClass: 'text-xs-center',
        },
      ],
      css: {
        table: {
          tableClass: 'v-table v-datatable',
          ascendingIcon: 'mdi mdi-sort-ascending',
          descendingIcon: 'mdi mdi-sort-descending',
        },
      },
      sortOrder: [
        { field: 'id', sortField: 'id', direction: 'asc' },
      ],
      boxes: [],
      editModalVisible: false,
      currentBox: {
        id: null,
        name: '',
        activated: null,
        note: '',
        status: null,
        last_status_update: null,
        organization_id: null,
        created_at: null,
        updated_at: null,
        magio_user: {
          username: '',
          password: '',
          box_id: null,
        },
      },
    };
  },
  methods: {
    getBoxStats(boxID) {
      this.$echo.private(`box-sync-${boxID}`);
      this.$store.dispatch(REQUEST_BOX_STATS, boxID);
    },
    syncBox(boxID) {
      const vm = this;

      axios.get(`${window.api_url}api/box/${boxID}/sync`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        });
    },
    syncBoxPlaylist(boxID) {
      const vm = this;

      axios.get(`${window.api_url}api/box/${boxID}/sync/playlists`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        });
    },
    syncBoxMedia(boxID) {
      const vm = this;

      axios.get(`${window.api_url}api/box/${boxID}/sync/media`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        });
    },
    showEditBoxDialog(box) {
      this.currentBox = box;
      this.editModalVisible = true;
    },
    editBox() {
      const vm = this;

      if (this.currentBox !== null) {
        axios.post(`${this.apiUrl}api/magio/user`, {
          username: this.currentBox.magio_user.username,
          password: this.currentBox.magio_user.password,
          box_id: this.currentBox.id,
        })
          .then((response) => {
            vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          })
          .catch((error) => {
            vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
          });
      }

      this.editModalVisible = false;
    },
  },
};
</script>

<style scoped>
.v-input--is-disabled:hover {
  cursor: pointer;
}
</style>
